import { isBbOrMbbSubscription } from '../../../common/utils/subscriptionUtils.js';
import type { Subscription } from '../../../generated/api/models.js';

export const showBroadbandInvitationInfo = (subscription: Subscription): boolean =>
  isBbOrMbbSubscription(subscription) && !!subscription.subscriptionContactId;
